module.exports = __webpack_public_path__ + "static/kdb-banner-2-47c17572988b91dd9a9084291e5727a2.webp";